import ChartJSContainer from "../../Componant/Charts/ChartJS";

const ChartJS = () => {
  return (
    <div className="page-body">
      <ChartJSContainer />
    </div>
  );
};

export default ChartJS;
